// requires faltantes do Wes
require('jquery-ui/ui/effect');
require('jquery-ui/ui/effects/effect-shake');
require('jquery-ui/ui/unique-id');
require('ace-diff/dist/ace-diff.min.js');

// ---------------------------------------------- //
//                      Style                     //
// ---------------------------------------------- //
import '~/Content/aga/plugins/bootstrap-switch/css/bootstrap-switch.min.css';
import '~/content/aga/css/aga.css';
import '~/content/aga/css/aga.tile.css';
import '~/content/aga/css/aga.grid.css';
import '~/content/aga/css/aga.number.css';
import '~/content/aga/css/dashboard.css';

// ---------------------------------------------- //
//                   JavaScript                   //
// ---------------------------------------------- //
require('~/Content/aga/plugins/bootstrap-switch/js/bootstrap-switch.min.js');

// Preparar globais
window.AGA = {};
window.AGADash = {};
require('~/content/aga/js/quick-nav.js');
require('~/content/aga/js/components/aga.js');
require('~/content/aga/js/components/aga.revealhandles.js');
require('~/content/aga/js/components/aga.menu.js');
require('~/content/aga/js/components/aga.helper.js');
require('~/content/aga/js/components/aga.loader.js');
require('~/content/aga/js/components/aga.form.js');
require('~/content/aga/js/components/aga.baseinputcontrol.js');
require('~/content/aga/js/components/aga.lookup.js');
require('~/content/aga/js/components/aga.text.js');
require('~/content/aga/js/components/aga.number.js');
require('~/content/aga/js/components/aga.date.js');
require('~/content/aga/js/components/aga.checkbox.js');
require('~/content/aga/js/components/aga.radio.js');
require('~/content/aga/js/components/aga.ajax.js');
require('~/content/aga/js/components/aga.grid.js');
require('~/content/aga/js/components/aga.textdecorator.js');
require('~/content/aga/js/components/aga.page.js');
require('~/content/aga/js/components/aga.init.js');
require('~/content/aga/js/components/aga.tile.js');
require('~/content/aga/js/components/aga.javascriptbutton.js');
require('~/content/aga/js/components/aga.quicknav.js');
require('~/content/aga/js/components/aga.tableCreator.js');
require('~/content/aga/js/components/aga.memo.js');
require('~/content/aga/js/components/aga.toastr.js');
require('~/content/aga/js/components/aga.userconfirmation.js');
require('~/content/aga/js/components/aga.schedule.js');
require('~/content/aga/js/components/aga.searchhider.js');
require('~/content/aga/js/components/aga.jargon.js');
require('~/content/aga/js/components/aga.dynamicquery.js');
require('~/content/aga/js/components/aga.ux-improvements.js');

require('~/content/aga/js/table.export.js');
require('~/content/aga/js/agadash/agadash.js');
require('~/content/aga/js/agadash/agadash.repository.js');
require('~/content/aga/js/agadash/agadash.events.js');
require('~/content/aga/js/agadash/agadash.panel.js');
require('~/content/aga/js/agadash/agadash.panel.tools.js');
require('~/content/aga/js/agadash/agadash.panel.render.js');
require('~/content/aga/js/agadash/agadash.filter.js');
require('~/content/aga/js/agadash/agadash.filter.render.js');
require('~/content/aga/js/agadash/agadash.filter.date.js');
require('~/content/aga/js/agadash/agadash.filter.predefined.js');
require('~/content/aga/js/agadash/agadash.filter.table.js');
require('~/content/aga/js/agadash/agadash.common.js');
require('~/content/aga/js/agadash/agadash.charts.js');
require('~/content/aga/js/agadash/agadash.pie.js');
require('~/content/aga/js/agadash/agadash.barsandstack.js');
require('~/content/aga/js/agadash/agadash.stack.js');
require('~/content/aga/js/agadash/agadash.bars.js');
require('~/content/aga/js/agadash/agadash.tiles.js');
require('~/content/aga/js/agadash/agadash.grid.js');
require('~/content/aga/js/agadash/agadash.details.js');
require('~/content/aga/js/agadash/agadash.pagination.js');
require('~/content/uc/js/topbar.js');

var brace = require('brace');
require('brace/mode/javascript');
require('brace/theme/monokai');
require("brace/ext/language_tools");
require("brace/mode/vbscript");

import AreaMap from '~/content/aga/js/AreaMap';
import PontoMovelCercas from '~/content/aga/js/ponto/cercasMap';
window.AGA.AreaMap = AreaMap;
window.AGA.PontoMovelCercas = PontoMovelCercas;

window.eSocial = {};
require('~/content/aga/js/eSocial/comparadorDeAuditorias.js');
require('~/content/aga/js/eSocial/comparadorDeXml.js');
require('~/content/aga/js/eSocial/formatadorDeXml.js');

window.RhUtils = {};
require('~/content/aga/js/adm/RhUtils.js');